/* eslint-disable id-length */

export const assets = {
    eThik: {
        LOGO: '/e-thik/logo',
    },

    flags: {
        'en-GB': '/flags/united_kingdom.svg',
        'es-ES': '/flags/spain.svg',
        'fr-FR': '/flags/france.svg',
    },

    nutriscore: {
        A: '/nutri-score/nutri-score_A.svg',
        B: '/nutri-score/nutri-score_B.svg',
        C: '/nutri-score/nutri-score_C.svg',
        D: '/nutri-score/nutri-score_D.svg',
        E: '/nutri-score/nutri-score_E.svg',
    },
}
